import Game from './components/game/game';


function App() {
  return (
    <div className="App">
      <Game/>
    </div>
  );
}


export default App;
